import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/css/reset.less';
import "../src/assets/css/public.css";

import utils from './assets/js/utils.js';
import api from './assets/js/api.js';

Vue.prototype.$utils=utils;

Vue.use(api);
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
